import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sf-modal-body"
}
const _hoisted_2 = { class: "sf-modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MathTestResult = _resolveComponent("MathTestResult")!
  const _component_SpellingTestResult = _resolveComponent("SpellingTestResult")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createBlock(_component_ModalDialog, {
    show: _ctx.showModal,
    onClosed: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closed')))
  }, {
    default: _withCtx(() => [
      (_ctx.testResultInfo && _ctx.student)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.subject == 'maths')
              ? (_openBlock(), _createBlock(_component_MathTestResult, {
                  key: 0,
                  "test-result-info": _ctx.testResultInfo,
                  student: _ctx.student
                }, null, 8, ["test-result-info", "student"]))
              : (_openBlock(), _createBlock(_component_SpellingTestResult, {
                  key: 1,
                  "test-result-info": _ctx.testResultInfo,
                  student: _ctx.student
                }, null, 8, ["test-result-info", "student"]))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.showModal = false), ["prevent"])),
          class: "sf-btn-primary"
        }, " Close ")
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}